import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { contactInfo, companyInfo } from '../data/mock';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

const ContactSection = () => {
  const { language, t, isRTL } = useLanguage();

  const getIcon = (iconName) => {
    switch (iconName) {
      case 'facebook':
        return <Facebook size={24} />;
      case 'instagram':
        return <Instagram size={24} />;
      default:
        return null;
    }
  };

  return (
    <section 
      id="contact" 
      className="relative py-32 bg-black"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/5 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-16">
          {t.contact.title}
        </h2>

        <div className="grid md:grid-cols-3 gap-12">
          {/* Social Media */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-white mb-6">
              {t.contact.followUs}
            </h3>
            <div className="flex justify-center gap-6">
              {contactInfo.social.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-white/10 hover:bg-white hover:text-black text-white transition-all duration-300 rounded-none"
                >
                  {getIcon(social.icon)}
                </a>
              ))}
            </div>
          </div>

          {/* Email */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-white mb-6">
              {t.contact.email}
            </h3>
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center justify-center gap-3 text-white/80 hover:text-white transition-colors text-lg"
            >
              <Mail size={20} />
              <span>{contactInfo.email}</span>
            </a>
          </div>

          {/* Phone Numbers */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-white mb-6">
              {t.contact.phone}
            </h3>
            <div className="space-y-4">
              {contactInfo.team.map((member, index) => (
                <div key={index} className="text-white/80">
                  <p className="font-medium text-white">{member.name[language]}</p>
                  <a 
                    href={`tel:${member.phone.replace(/\s/g, '')}`}
                    className="flex items-center justify-center gap-2 hover:text-white transition-colors"
                  >
                    <Phone size={16} />
                    <span dir="ltr">{member.phone}</span>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
